import { useState } from 'react'
import api from '../services/api'
import LookupSelect from '../components/LookupSelect'

// Importar registros de abastecimentos por planilha (GeneXus WDPS082), em Combustível → Importações.
interface Posto { pracod: string; pranom: string; pracgc: string; laypos_cod: number; laypos_des: string | null; laypos_sta: string | null; uf: string; ok: boolean; erro: string }

function formatarCnpj(v: string) {
  const d = (v || '').replace(/\D/g, '')
  if (!d || d === '0') return ''
  return d.padStart(14, '0').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
}

function Campo({ label, width, children }: { label: string; width?: number | string; children: React.ReactNode }) {
  return (
    <div className="field-cad" style={{ width }}>
      <label style={{ display: 'block', minHeight: '1.1rem', lineHeight: 1.2 }}>{label}</label>
      {children}
    </div>
  )
}

const secao: React.CSSProperties = {
  background: '#f7faff', border: '1px solid #eef0f4', borderLeft: '4px solid #1a6ea8', borderRadius: '0.5rem', padding: '0.55rem 0.85rem',
  marginBottom: '0.55rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem 0.9rem', alignItems: 'flex-end',
}

export default function ImportacaoExcelAbastecimentos() {
  const [pracod, setPracod] = useState('')
  const [posto, setPosto] = useState<Posto | null>(null)
  const [arquivo, setArquivo] = useState<File | null>(null)
  const [opcao, setOpcao] = useState('V')
  const [sohErros, setSohErros] = useState(false)
  const [validarVeiculo, setValidarVeiculo] = useState('P')
  const [valorLitro, setValorLitro] = useState('A')
  const [msg, setMsg] = useState<{ texto: string; ok: boolean } | null>(null)

  async function escolherPosto(cod: string) {
    setPracod(cod); setPosto(null); setMsg(null)
    if (!cod) return
    try {
      const p: Posto = (await api.get(`/importacao-abastecimento/posto/${encodeURIComponent(cod)}`)).data
      setPosto(p)
      if (!p.ok) setMsg({ texto: p.erro, ok: false })
    } catch (e: any) {
      setMsg({ texto: e?.response?.data?.error || 'Erro ao buscar posto.', ok: false })
    }
  }

  function processar() {
    if (!pracod) return setMsg({ texto: 'Informe o código do posto!', ok: false })
    if (!posto?.ok) return setMsg({ texto: posto?.erro || 'Posto não cadastrado!', ok: false })
    if (!arquivo) return setMsg({ texto: 'Selecione o arquivo a ser importado!', ok: false })
    setMsg({ texto: 'Leitura da planilha ainda não implementada (falta a rotina PARQ00E).', ok: false })
  }

  return (
    <div className="card" style={{ maxWidth: 900 }}>
      <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1a6ea8', marginBottom: '0.8rem', paddingBottom: '0.5rem', borderBottom: '2px solid #eff6ff' }}>
        Importar Registros de Abastecimentos (planilha Excel)
      </h3>

      <div style={secao}>
        <Campo label="Posto" width={300}>
          <LookupSelect endpoint="/erp/pracas/lista" codKey="pracod" descKey="pranom" tagKey="pracod"
            codValue={pracod} descValue={posto?.pranom || pracod}
            valorExibido={pracod ? `${pracod} - ${posto?.pranom || ''}` : ''}
            onSelect={cod => escolherPosto(cod)} placeholder="Buscar posto..." listWidth={320} />
        </Campo>
        <Campo label="CNPJ" width={170}>
          <input type="text" value={formatarCnpj(posto?.pracgc || '')} disabled style={{ width: '100%' }} />
        </Campo>
        <Campo label="UF" width={50}>
          <input type="text" value={posto?.uf || ''} disabled style={{ width: '100%' }} />
        </Campo>
      </div>

      <div style={secao}>
        <Campo label="Layout" width={60}>
          <input type="text" value={posto?.laypos_cod || ''} disabled style={{ width: '100%', textAlign: 'right' }} />
        </Campo>
        <Campo label="Descrição do Layout" width={340}>
          <input type="text" value={posto?.laypos_des || ''} disabled style={{ width: '100%' }} />
        </Campo>
        <Campo label="Status" width={90}>
          <input type="text" value={posto?.laypos_sta ? (posto.laypos_sta === 'I' ? 'Inativo' : 'Ativo') : ''} disabled style={{ width: '100%' }} />
        </Campo>
      </div>

      <div style={secao}>
        <Campo label="Arquivo" width={480}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <label style={{ padding: '0.4rem 0.9rem', background: '#15803d', color: '#fff', borderRadius: 6, fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer', whiteSpace: 'nowrap' }}>
              📊 Escolher planilha
              <input type="file" accept=".xls,.xlsx" onChange={e => { setArquivo(e.target.files?.[0] || null); setMsg(null) }} style={{ display: 'none' }} />
            </label>
            <span style={{ fontSize: '0.82rem', color: arquivo ? '#111827' : '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {arquivo ? arquivo.name : 'Nenhum arquivo selecionado'}
            </span>
          </div>
        </Campo>
      </div>

      <div style={secao}>
        <Campo label="Opção" width={170}>
          <select value={opcao} onChange={e => setOpcao(e.target.value)} style={{ width: '100%' }}>
            <option value="V">Verificar dados</option>
            <option value="I">Importar</option>
          </select>
        </Campo>
        <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: '0.82rem', color: '#374151', paddingBottom: 6, cursor: 'pointer' }}>
          <input type="checkbox" checked={sohErros} onChange={e => setSohErros(e.target.checked)} /> Só listar registros com erros
        </label>
        <Campo label="Validar Veículo" width={140}>
          <select value={validarVeiculo} onChange={e => setValidarVeiculo(e.target.value)} style={{ width: '100%' }}>
            <option value="P">Pela Placa</option>
            <option value="C">Pelo Código</option>
          </select>
        </Campo>
        <Campo label="Valor por Litro" width={140}>
          <select value={valorLitro} onChange={e => setValorLitro(e.target.value)} style={{ width: '100%' }}>
            <option value="A">do Arquivo</option>
            <option value="T">da Tabela</option>
          </select>
        </Campo>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <button className="btn btn-primary" onClick={processar}>{opcao === 'I' ? 'Importar' : 'Verificar'}</button>
        {msg && (
          <span style={{ fontSize: '0.8rem', fontWeight: 600, padding: '0.35rem 0.8rem', borderRadius: 6, background: msg.ok ? '#d1fae5' : '#fee2e2', color: msg.ok ? '#065f46' : '#991b1b' }}>{msg.texto}</span>
        )}
      </div>
    </div>
  )
}
